export default {
  // 导航菜单
  menu: {
    home: 'Home',
    campaign: 'Campaign',
    report: 'Report',
    dna: 'DNA',
  },
  
  // 用户菜单
  userMenu: {
    timezone: 'Timezone',
    billingAndPayments: 'Billing & Payments',
    plan: 'Plan',
    couponCode: 'Coupon code',
    workspace: 'Workspace',
    messages: 'Messages',
    helpAndFeedback: 'Help & Feedback',
    language: 'Language',
  },
  
  // 操作按钮
  actions: {
    copyLink: 'Copy link',
    invitationCode: 'Invitation code',
    logIn: 'Log in',
    startForFree: 'Start for free',
  },
  
  // 工具提示
  tooltips: {
    copyLink: 'Copy link',
  },
  
  // 消息提示
  messages: {
    copySuccess: 'Copy success.',
    copyFail: 'Copy fail.',
  },
  
  // 状态显示
  status: {
    beta: 'Beta',
  },
};
